export const STANDALONE_ONBOARDING_IMAGE =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/58f9a25a595e77f3bdeca9370c9a347f-1753797898834/routing.png';
